import { peekCache } from './queryCache';

export function peekOwnerCache(suffix) {
  return peekCache(`owner:${suffix}`);
}
